export var FEATURE_FLAG_NAMES;
(function (FEATURE_FLAG_NAMES) {
    FEATURE_FLAG_NAMES["COPILOT_ENABLED"] = "copilot-enabled";
    FEATURE_FLAG_NAMES["COPILOT_QUERY_DIFF_ENABLED"] = "copilot-query-diff";
    FEATURE_FLAG_NAMES["COPILOT_ANSWER_SAVE_LIMIT"] = "copilot-answer-save-limit";
    FEATURE_FLAG_NAMES["SHOW_QUERY_BY_DEFAULT_FOR_CONVASSIST"] = "enableShowQueryByDefaultForConvAssist";
    FEATURE_FLAG_NAMES["ENABLE_CONVASSIST"] = "enableConvAssist";
    FEATURE_FLAG_NAMES["ENABLE_SAGE_TRAIN"] = "enableSageTrain";
    FEATURE_FLAG_NAMES["ERROR_CODES_WITH_CUSTOM_ERROR_DETAILS_MODAL_TITLE"] = "error-codes-with-custom-title-in-error-details-modal";
    FEATURE_FLAG_NAMES["ERROR_CODES_WITH_PUBLIC_DOCS"] = "error-codes-with-public-docs";
    FEATURE_FLAG_NAMES["IS_VISUAL_EMBED_V2_PLAYGROUND_ENABLED"] = "enablePlaygroundV2";
    FEATURE_FLAG_NAMES["ENABLE_ASK_SAGE_RIGHT_PANEL"] = "enableAskSageRightPanel";
    FEATURE_FLAG_NAMES["ENABLE_CONV_ASSIST_FRAGMENT_FEEDBACK"] = "enableConvAssistFragmentFeedback";
    FEATURE_FLAG_NAMES["COPILOT_INTRO_VIDEO"] = "copilot-intro-video";
    FEATURE_FLAG_NAMES["ENABLE_CONV_ASSIST_DATA_LITERACY"] = "enableConvAssistDataLiteracy";
    FEATURE_FLAG_NAMES["CONV_ASSIST_ANSWER_ACTIONS"] = "convAssistAnswerActions";
    FEATURE_FLAG_NAMES["SHOW_QUERY_DIFF"] = "showQueryDiff";
    FEATURE_FLAG_NAMES["OBSERVABILITY_CONFIG"] = "observabilityConfig";
    FEATURE_FLAG_NAMES["ORG_PER_CUSTOM_EMBED_URL_FLAG_KEY"] = "orgPerCustomEmbedUrl";
    FEATURE_FLAG_NAMES["CONV_ASSIST_PROMPT_SUGGESTIONS"] = "convAssistPromptSuggestions";
    FEATURE_FLAG_NAMES["ENABLE_CONVEX_EXPERIENCE"] = "enableConvexExperience";
    FEATURE_FLAG_NAMES["ENABLE_CONV_ASSIST_ANSWER_BANNER"] = "enableConvAssistAnswerBanner";
    FEATURE_FLAG_NAMES["ENABLE_NL_INSTRUCTIONS"] = "enableNLInstructions";
    FEATURE_FLAG_NAMES["ENABLE_CCA_SUMMARY_TAB"] = "enableCCASummaryTab";
    FEATURE_FLAG_NAMES["ENABLE_ANOMALY_V2_CTA"] = "enableAnomalyV2";
    FEATURE_FLAG_NAMES["ENABLE_KPI_ANOMALY_V2"] = "enableKPIWithAnomalyV2";
    FEATURE_FLAG_NAMES["ENABLE_FULL_AI_HIGHLIGHTS_MODAL"] = "enableFullAIHighlightsModal";
    FEATURE_FLAG_NAMES["ENABLE_SPOTTER_IN_SEARCH_DATA"] = "enable-spotter-in-search-data";
    FEATURE_FLAG_NAMES["ENABLE_FQS"] = "enableFQS";
    FEATURE_FLAG_NAMES["ENABLE_CONVEX_TOGGLE_BUTTON"] = "isConvexToggleButton";
    FEATURE_FLAG_NAMES["ENABLE_CCA_CONVEX_TOOLS"] = "convexTools.cca.enable";
    FEATURE_FLAG_NAMES["ENABLE_SPOTTER_SHORTCUTS"] = "enableSpotterShortcuts";
    FEATURE_FLAG_NAMES["ENABLE_KC_IN_SPOTTER"] = "enableKCInSpotter";
    FEATURE_FLAG_NAMES["HOST_EVENT_PARAMETERIZATION"] = "embed-hostEventParameterization";
    FEATURE_FLAG_NAMES["ENABLE_SPOTTER_WORKSHEET_TABLE_PREVIEW"] = "enableSpotterWorksheetTablePreview";
    FEATURE_FLAG_NAMES["ENABLE_ASSUMPTIONS_BY_LLM"] = "enableAssumptionsByLLM";
    FEATURE_FLAG_NAMES["NAVIGATION_VERSION"] = "navigationVersion";
    FEATURE_FLAG_NAMES["EDGE_ONBOARDING_INTRO_VIDEO"] = "edge-onboarding-intro-video";
    FEATURE_FLAG_NAMES["AI_HIGHLIGHTS_DISTRIBUTION"] = "ai-highlights-distribution";
    FEATURE_FLAG_NAMES["SPOTIQ_MAX_DRILL_ATTRIBUTES_LIMIT"] = "spotiq-max-drill-attributes-limit";
    FEATURE_FLAG_NAMES["SPOTIQ_MAX_MEASURES_LIMIT"] = "spotiq-max-measures-limit";
    FEATURE_FLAG_NAMES["WATCHLIST_V2"] = "enableWatchlistV2";
    FEATURE_FLAG_NAMES["IS_TML_DIFF_V2_ENABLED"] = "enableTMLDiffV2";
    FEATURE_FLAG_NAMES["ENABLE_SPOTTER_OPTIMIZATION_TAB"] = "enableSpotterOptimizationTab";
    FEATURE_FLAG_NAMES["IS_NEW_LLM_CONFIGURATION"] = "is-new-llm-configuration";
    FEATURE_FLAG_NAMES["IS_SERVICE_WORKER_ENABLED"] = "isServiceWorkerEnabled";
    FEATURE_FLAG_NAMES["ENABLE_GROUPS_FREE_TRIAL"] = "enableGroupsFreeTrial";
    FEATURE_FLAG_NAMES["ENABLE_SPOTTER_ATAC_WORKFLOW"] = "enableSpotterATACWorkflow";
    FEATURE_FLAG_NAMES["ENABLE_SPOTTER_ATAC_TOKEN_HIGHLIGHT"] = "enableSpotterATACTokenHighlight";
    FEATURE_FLAG_NAMES["CSV_UPLOAD_V2_ENABLED"] = "csvUploadV2Enabled";
    FEATURE_FLAG_NAMES["ENABLE_PENDO_FROM_EXCEPTION_LIST"] = "enablePendoFromExceptionList";
    FEATURE_FLAG_NAMES["ENABLE_PENDO_HELP"] = "enablePendoHelp";
    FEATURE_FLAG_NAMES["ENABLE_MOBILE_WEBVIEW_MESSAGING"] = "embed-enableMobileWebViewMessaging";
    FEATURE_FLAG_NAMES["ENABLE_FEEDBACK_EXPORT"] = "exportFeedbackFromCoachSpotter";
    FEATURE_FLAG_NAMES["ENABLE_BOOK_CALL_EDGE"] = "enableBookOneToOneCallEdge";
})(FEATURE_FLAG_NAMES || (FEATURE_FLAG_NAMES = {}));
export var ContextType;
(function (ContextType) {
    ContextType["USER"] = "user";
})(ContextType || (ContextType = {}));
export const DEFAULT_FLAG_VALUE = false;
//# sourceMappingURL=flags.const.js.map